import React, { useMemo } from "react";
import { useGetOdysseeStatQuery } from "../../store/api/odyssee";
import { useParams } from "react-router-dom";
import { useAuthToken } from "../../hooks/auth";
import { Box, useMediaQuery } from "@mui/material";
import { useIsMobile } from "../../hooks/responsive";
import CommunityPng from "../../resources/images/png/COMMU.png";


const colors = ["#A5D0C9", "#C7C4DE", "#A5D0C9", "#EF7D8F", "#FBF0E5"];

const UserAvatar = ({ title, ...props }) => {
	return (
		<Box
			{...props}
			sx={{
				width: 45,
				height: 45,
				borderRadius: "50%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "orange",
				boxShadow: (theme) => theme.shadows[24],
				fontSize: "16px",
				color: "black",
				...props.style,
			}}
		>
			{title}
		</Box>
	);
};

const OdysseeCommunityStat = ({ variant = "menu", odysseeId, ...props }) => {
	//const { odysseeId } = useParams();
	const authToken = useAuthToken();
	const { data } = useGetOdysseeStatQuery({ id: odysseeId, authToken });

	const names = React.useMemo(() => {
		if (!data) return [];
		return data.items.map((user) => {
			const firstName = user.prenom.trim();
			return `${firstName.charAt(0).toUpperCase()}${firstName.substring(1)}`;
		});
	}, [data]);

	const isMobile = useIsMobile();

	const users = React.useMemo(() => {
		if (!data) return [];
		return data.items.filter((user, i) => {
			return isMobile ? i < 2 : true;
		});
	}, [data, isMobile]);

	const text = React.useMemo(() => {
		if (variant === "menu") {
			return "autres personnes participent à l'odyssée";
		} else {
			return "autres explorateurs sont passés par là";
		}
	}, [variant]);

	if (!data) return null;

	return (
		<Box
			sx={{
				color: "white",
				borderRadius: "45px",
				marginTop: 5,
				fontSize: "20px",
				backgroundColor: "#00000033",
				padding: "20px 20px",
				fontFamily: "Branding Semibold",
				alignItems: "center",
				justifyContent: "space-between",
				display: "flex",
				flexDirection: "row",
				lineHeight: "1.2em",
				marginRight: "3vw",
				marginLeft: "calc(3vw + 115px)",
				paddingLeft: "60px",
				position: "relative",
				marginBottom: 5,
				opacity: 0.6,
			}}
		>
			<Box
				sx={{
					boxShadow: (theme) => theme.shadows[5],
					width: "115px",
					height: "115px",
					borderRadius: "50%",
					overflow: "hidden",
					position: "absolute",
					top: "50%",
					transform: "translate(-60%, -50%)",
					left: "0px",
					backgroundColor: "#483d3d8c"
				}}
			>
				<img
					alt={"odysee picture"}
					src={CommunityPng}
					style={{
						objectFit: "cover",
						width: "100%",
						height: "100%",
					}}
				/>
			</Box>
			{`${names.reduce((acc, curr) => `${acc.trim()}, ${curr}`)} et ${data.totalAccounts - users.length} ${text}`}
			<Box
				sx={{
					marginLeft: 4,
					display: "flex",
					flexDirection: "row",
				}}
			>
				{users.map((user, index) => {
					return (
						<UserAvatar
							key={index}
							title={user.prenom.trim().charAt(0).toUpperCase()}
							style={{
								marginLeft: "-10px",
								backgroundColor: colors[index % 5],
							}}
						/>
					);
				})}
				<UserAvatar
					title={`+${Math.min(999, data.totalAccounts - 4)}`}
					style={{
						marginLeft: "-10px",
						backgroundColor: colors[users.length % 5],
					}}
				/>
			</Box>
		</Box>
	);
};
export default OdysseeCommunityStat;
